module.exports = __webpack_public_path__ + "img/ENALP.6d558e13.png";